import {
  createRouter,
  createWebHistory,
  type NavigationGuardNext,
  type NavigationGuardWithThis,
  type RouteLocationNormalizedGeneric
} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { auth } from '@/stores/auth'
import Dashboard from '@/views/Dashboard.vue'
import NProgress from 'nprogress'
import colors from 'tailwindcss/colors'
import { sendPageVisit } from '@/services/tracking'
import { context } from '@/services'
import { getOrCreateSession } from '@/services/tracking-sessions'
import { useGlobalStore } from '@/stores/global'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Dashboard,
      meta: {
        requiresAuth: true,
        id: 1,
        translation: 'الرئيسية'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/Login.vue'),
      meta: {
        guest: true,
        translation: 'تسجيل الدخول',

        id: 2
      }
    },
    {
      path: '/mosque-presence-dashboard',
      name: 'mosque-presence-dashboard',
      component: () => import('../views/MosquePresenceDashboard.vue'),
      meta: {
        requiresAuth: true,
        id: 201,
        translation: 'إحصائيات حضور المسجد'
      }
    },

    // * Admin Routes

    {
      path: '/admin/login',
      name: 'admin-login',
      meta: {
        guest: true
      },
      component: () => import('../views/admin/AdminLogin.vue')
    },
    {
      path: '/admin',
      name: 'admin',
      meta: {
        guest: true
      },
      redirect: '/admin/login'
    },
    {
      path: '/admin/visits',
      name: 'admin-visits',
      meta: {
        requiresAuth: true
      },
      component: () => import('../views/admin/Visits.vue')
    },
    {
      path: '/admin/interactions',
      name: 'admin-interactions',
      meta: {
        requiresAuth: true
      },
      component: () => import('../views/admin/Interactions.vue')
    },

    {
      path: '/admin/session-replays',
      name: 'admin-session-replays',
      meta: {
        requiresAuth: true
      },
      component: () => import('../views/admin/SessionReplays.vue')
    },
    {
      path: '/admin/profile',
      name: 'admin-profile',
      meta: {
        requiresAuth: true
      },
      component: () => import('../views/admin/AdminProfile.vue')
    },
    {
      path: '/admin/users',
      name: 'admin-users',
      meta: {
        requiresAuth: true
      },
      component: () => import('../views/admin/Users.vue')
    },
    {
      path: '/admin/whatsapp-config',
      name: 'admin-whatsapp-config',
      meta: {
        requiresAuth: true
      },
      component: () => import('../views/admin/WhatsAppConfig.vue')
    }
  ]
})

const adminAuth = ({
  to,
  from,
  next
}: {
  to: RouteLocationNormalizedGeneric
  from: RouteLocationNormalizedGeneric
  next: NavigationGuardNext
}) => {
  const admin = localStorage.getItem('admin')
    ? JSON.parse(localStorage.getItem('admin') as string)
    : null

  if (to.meta.requiresAuth && !admin) {
    return next({ name: 'admin-login' })
  }
  if (to.meta.guest && admin) {
    return next({ name: 'admin-visits' })
  }

  return next()
}

router.beforeEach(async (to, from, next) => {
  NProgress.start()

  const loader = document.getElementById('initial-loader')
  // if (to.name?.toString().startsWith('admin')) {
  //   if (loader) {
  //     document.body.removeChild(loader as ChildNode)
  //   }
  //   return adminAuth({ to, from, next })
  // }

  const authStore = auth()
  await authStore.init()

  if (loader) {
    document.body.removeChild(loader as ChildNode)
  }
  if (to.meta.requiresAuth && !authStore.user) {
    console.log('not auth')

    return next({ name: 'login' })
  }

  if (to.meta.guest && authStore.user) {
    return next({ name: 'home' })
  }

  if (context == 'bayen_school') {
    document.documentElement.style.setProperty('--color-primary', '#d6336c')
    document.documentElement.style.setProperty('--color-background', '#faf1f4')
  }

  return next()
})

router.afterEach(async (to) => {
  NProgress.done()

  const authStore = auth()

  if (!authStore.user) return

  const trackingSessionId = await getOrCreateSession()

  const { visit } = await sendPageVisit(
    authStore.user.name,
    to.name as string,
    authStore.user.user_branches.current_branch_id,
    authStore.user.user_branches.current_branch_name,
    to.path,
    trackingSessionId
  )

  const globalStore = useGlobalStore()

  globalStore.currentVisitId = visit.id
})

export default router
